import { Col, Row } from "react-bootstrap";

const DwellingDiagnosticSurfaceForm = ({ register }: { register: any }) => {
  return (
    <div className="mt-3">
      <div className="d-flex d-flex-row justify-content-between">
        <h2
          className="fw-bold main-title mb-3"
          style={{
            fontSize: "24px",
          }}
        >
          Surface
        </h2>
      </div>

      <div className="bg-container bg-container-form">
        <div className="d-flex flex-column flex-md-row flex-wrap gap-5">
          <Row className="w-100">
            <Col md={3}>
              <label className="w-100 add-prop-label ms-2">
                Superficie habitable :{" "}
              </label>
              <Col sm={5}>
                <input
                  {...register("area.living")}
                  className="w-100 add-prop-input"
                  type="number"
                  placeholder="m²"
                  step="0.01"
                />
              </Col>
            </Col>

            <Col md={3}>
              <label className="w-100 add-prop-label ms-2">
                Superficie Carrez :
              </label>
              <Col sm={5}>
                <input
                  {...register("area.carrez")}
                  className="w-100 add-prop-input"
                  type="number"
                  placeholder="m²"
                  step="0.01"
                />
              </Col>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default DwellingDiagnosticSurfaceForm;
